import React, { useContext, useEffect } from 'react';
import { useEvent } from '../../../../contexts/event-bus';
import { MapPaddingContext } from '../../../../contexts/map-padding-context';
import { useWorkspaceItemContext } from '../../../../contexts/workspace/workspace-item-context';
import { useAppSelector } from '../../../../hooks/store-hooks';
import useMap from '../../../../hooks/use-map';
import { encompassFlight } from '../../../../utils/encompass';
import { useWorkspace } from '../../hooks/use-view';

export default function FlightSelection() {
    const workspaceId = useWorkspaceItemContext().id;
    const workspaceState = useAppSelector((x) => x.workspace);
    const encompass = useWorkspace((x) => x.flights.settings.encompass);
    const map = useMap();
    const padding = useContext(MapPaddingContext);
    const workspaceLayout = useAppSelector((x) => x.workspace.layout);

    useEvent(
        'flight-selected',
        React.useCallback(
            (args) => {
                const flight = args.details;
                if (!map) {
                    return;
                }
                const { source } = args.options;
                if (encompass) {
                    // Provide proper padding for single map layout, good enough for now.
                    encompassFlight(map, workspaceState.items[workspaceId].flights.selected, workspaceLayout === 0 ? padding : undefined);
                } else {
                    if (source !== 'manual' && source !== 'side-effect') {
                        const zoom = flight.speed < 50 ? 14 : flight.speed < 200 ? 10 : 6;
                        if (workspaceId === workspaceState.selectedId) {
                            map?.goToFlight(flight.position, zoom);
                        }
                    }
                }
            },
            [map, encompass, workspaceId, workspaceState, padding, workspaceLayout]
        )
    );

    useEffect(() => {
        if (!map || !encompass) {
            return;
        }
        encompassFlight(map, workspaceState.items[workspaceId].flights.selected, workspaceLayout === 0 ? padding : undefined);
    }, [map]);

    return <></>;
}
